exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n  .card__header{\r\n    -webkit-box-shadow: none;\r\n            box-shadow: none;\r\n  }\r\n  .card.form-container{\r\n    -webkit-box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);\r\n            box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);\r\n  }\r\n  .container{\r\n    width: 100% !important;\r\n  }\r\n  .card__content {\r\n    display:  grid;\r\n    grid-template-columns: repeat(5,1fr);\r\n    text-align: center;\r\n}\r\n  .transaction-history {\r\n    display:  grid;\r\n    grid-template-columns:  1fr;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/transaction-update-form/transaction-update-form.component.css
// module id = ../../../../../src/app/shared/components/transaction-update-form/transaction-update-form.component.css
// module chunks = main